// extracted by mini-css-extract-plugin
export default {"view":"ProjectGrid_view__tRe+k","image":"ProjectGrid_image__LD3Ux","info":"ProjectGrid_info__VIWkj","title":"ProjectGrid_title__AQN-w","desc":"ProjectGrid_desc__FRA6e"};